// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gmPage {
  position: relative;
  width: 100%;
  min-height: calc(100vh - 76px);
  margin-top: 0 !important;
  padding: 0 0 32px;
  background: var(--surface-page, #f8fafc);
  color: var(--text-body, #334155);
}

.gmShell {
  position: relative;
  width: 100%;
  max-width: none;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.gmPageHeader {
  display: flex;
  width: calc(100% + 48px);
  height: 70px;
  min-height: 70px;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  margin: -20px 0 18px -24px;
  padding: 0 72px 0 28px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}

.gmPageHeader h1 {
  flex: 0 0 auto;
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 22px;
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -0.015em;
  white-space: nowrap;
}

.gmListCard {
  overflow: visible;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-lg, 12px);
  background: var(--surface-card, #fff);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.gmHeader,
.gmToolbar,
.gmSelectionBar,
.gmFooter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.gmHeader h1 {
  margin: 0;
  font-size: 24px;
  line-height: 1.2;
  font-weight: 700;
  color: var(--text-strong, #101828);
  letter-spacing: 0;
}

.gmHeader h1 span {
  display: inline-flex;
  align-items: center;
  min-width: 26px;
  height: 24px;
  padding: 0 8px;
  margin-left: 8px;
  border-radius: 999px;
  background: #eef2f6;
  color: #475467;
  font-size: 13px;
  font-weight: 700;
}

.gmHeader p {
  margin: 5px 0 0;
  color: var(--text-muted, #667085);
  font-size: 13px;
}

.gmButton,
.gmIconButton {
  border: 1px solid transparent;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  height: 36px;
  padding: 0 13px;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.gmButton svg,
.gmIconButton svg,
.gmSearch svg,
.gmChannel svg,
.gmDrawerChannels svg,
.gmModalIcon svg,
.gmEmpty svg {
  width: 16px;
  height: 16px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
  flex: 0 0 auto;
}

.gmButton--primary {
  background: var(--action-primary, #227ebd);
  color: #fff;
  border-color: var(--action-primary, #227ebd);
}

.gmButton--primary:hover {
  background: var(--action-primary-hover, #1a6da3);
  border-color: var(--action-primary-hover, #1a6da3);
}

.gmCreateIcon {
  font-size: 18px;
  font-weight: 500;
  line-height: 1;
}

.gmButton--secondary {
  background: #fff;
  color: #1f4f63;
  border-color: #c8d7df;
}

.gmButton--secondary:hover {
  background: #f4fafc;
}

.gmButton--ghost {
  background: #fff;
  color: #475467;
  border-color: #d0d5dd;
}

.gmButton--ghost:disabled {
  opacity: 0.55;
  cursor: default;
}

.gmButton--danger {
  background: var(--red-500, #da4453);
  color: #fff;
  border-color: transparent;
}

.gmButton--danger:hover {
  background: var(--red-600, #c4313f);
  box-shadow: 0 4px 12px rgba(218, 68, 83, 0.28);
}

.gmTabs {
  display: flex;
  min-width: 0;
  flex: 1 1 auto;
  align-self: stretch;
  align-items: stretch;
  gap: 26px;
  overflow-x: auto;
  margin: 0;
  border-bottom: 0;
}

.gmTabs button {
  position: relative;
  display: inline-flex;
  height: auto;
  flex: 0 0 auto;
  align-items: center;
  gap: 7px;
  border: 0;
  background: transparent;
  color: var(--text-muted, #64748b);
  padding: 1px 0 0;
  font-size: 15px;
  font-weight: 650;
  cursor: pointer;
  white-space: nowrap;
}

.gmTabs button.is-active {
  color: var(--blue-600, #1a6da3);
}

.gmTabs button.is-active::after {
  content: '';
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 3px;
  border-radius: 3px 3px 0 0;
  background: var(--action-primary, #227ebd);
}

.gmTabs span {
  display: inline-flex;
  min-width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  border-radius: 999px;
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
}

.gmTabs button.is-active span {
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.gmPageHeader > .gmButton {
  height: 40px;
  min-height: 40px;
  flex: 0 0 auto;
  border-radius: var(--radius-md, 8px);
  font-size: 14px;
  font-weight: 650;
}

.gmSentScopes {
  display: inline-flex;
  width: fit-content;
  gap: 4px;
  padding: 4px;
  border: 0;
  border-radius: 10px;
  background: var(--surface-sunken, #f1f5f9);
}

.gmSentScopes button {
  display: inline-flex;
  height: 30px;
  align-items: center;
  gap: 6px;
  padding: 0 13px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #667085;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.gmSentScopes button.is-active {
  background: #fff;
  color: #155d8c;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.12);
}

.gmToolbar {
  order: initial;
  min-height: 64px;
  justify-content: flex-start;
  padding: 12px 16px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 12px 12px 0 0;
  background: var(--surface-card, #fff);
}

.gmToolbarHeading {
  flex: 0 0 auto;
  margin: 0 6px 0 0;
  color: var(--text-strong, #101828);
  font-size: 24px;
  line-height: 1.2;
  font-weight: 700;
  white-space: nowrap;
}

.gmToolbarHeading span {
  display: inline-flex;
  min-width: 26px;
  height: 24px;
  margin-left: 8px;
  padding: 0 8px;
  border-radius: 999px;
  background: #eef2f6;
  color: #475467;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  vertical-align: middle;
}

.gmToolbar .gmButton {
  height: 40px;
  min-height: 40px;
}
.gmToolbarTitle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-right: 2px;
}
.gmToolbarTitle strong {
  color: #101828;
  font-size: 15px;
}
.gmToolbarTitle span {
  display: inline-flex;
  min-width: 24px;
  height: 22px;
  align-items: center;
  justify-content: center;
  padding: 0 7px;
  border-radius: 999px;
  background: #eef2f6;
  color: #667085;
  font-size: 11px;
  font-weight: 800;
}
.gmToolbarSpacer {
  flex: 1;
}

.gmSearch {
  height: 38px;
  width: min(420px, 100%);
  flex: 0 1 420px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  background: #fff;
  color: #667085;
  margin-bottom: 0;
}
.gmFilterButton {
  position: relative;
  display: inline-flex;
  width: auto;
  min-width: 40px;
  height: 38px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 12px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: #334155;
  cursor: pointer;
  font-size: 12.5px;
  font-weight: 700;
  white-space: nowrap;
}
.gmFilterButton svg {
  width: 18px;
  height: 18px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.gmFilterButton:hover,
.gmFilterButton.is-active {
  border-color: #6fb1df;
  background: #eef6fc;
  color: #155d8c;
}
.gmFilterButton > b {
  position: static;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 19px;
  height: 19px;
  padding: 0 5px;
  border-radius: 999px;
  background: #227ebd;
  color: #fff;
  font-size: 10.5px;
  font-weight: 800;
}
.gmFilters {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: auto;
  z-index: 1200;
  display: flex;
  width: min(360px, calc(100vw - 20px));
  flex-direction: column;
  gap: 0;
  align-items: stretch;
  padding: 0;
  overflow-x: hidden;
  overflow-y: hidden;
  border: 0;
  border-left: 1px solid #d9e2ec;
  border-radius: 0;
  background: #fff;
  box-shadow: -12px 0 34px rgba(15, 23, 42, 0.14);
}

.gmFiltersBody {
  display: flex;
  min-height: 0;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 14px;
  padding: 18px 18px 24px;
  overflow-x: hidden;
  overflow-y: auto;
}

.gmFiltersHeader {
  display: flex;
  min-height: 38px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
}

.gmFiltersHeader strong {
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 18px;
  font-weight: 800;
}

.gmFiltersHeader button {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  background: var(--surface-card, #fff);
  color: var(--text-muted, #64748b);
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
}

.gmFiltersHeader button:hover {
  border-color: var(--blue-500, #227ebd);
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}
.gmFilters label {
  display: flex;
  margin: 0;
  flex-direction: column;
  gap: 6px;
}
.gmFilters label > span {
  color: #475467;
  font-size: 12px;
  font-weight: 700;
}

.gmFilters .gmInput {
  width: 100%;
  height: 38px;
  padding: 0 11px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  outline: none;
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
  font: 400 13px var(--font-body, 'Public Sans', system-ui, sans-serif);
}

.gmFilters .gmInput:focus {
  border-color: var(--blue-500, #227ebd);
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.16);
}

.gmFilterChoices {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

.gmFilterChoices legend {
  margin-bottom: 7px;
  color: #475467;
  font-size: 12px;
  font-weight: 700;
}

.gmFilterChoices > div {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.gmFilterChoices button {
  height: 30px;
  padding: 0 10px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: #334155;
  font-size: 11.5px;
  font-weight: 700;
  cursor: pointer;
}

.gmFilterChoices button.is-active {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}
.gmFiltersActions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: auto;
  padding-top: 14px;
  border-top: 1px solid #e5e9f0;
}

.gmFiltersActions__spacer {
  flex: 1 1 auto;
}

.gmFilterClear,
.gmFilterChips__clear {
  padding: 0;
  border: 0;
  background: transparent;
  color: #1c5d8c;
  font-size: 11.5px;
  font-weight: 700;
  cursor: pointer;
}

.gmFilterClear:hover,
.gmFilterChips__clear:hover {
  text-decoration: underline;
}

.gmFilterChips {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 46px;
  padding: 10px 16px;
  flex-wrap: wrap;
  border-bottom: 1px solid #e5e9f0;
}

.gmFilterChip {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  gap: 6px;
  padding: 0 10px;
  border-radius: 999px;
  background: #eaf3fb;
  color: #1c5d8c;
  font-size: 11.5px;
  font-weight: 700;
}

.gmFilterChip button {
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font-size: 15px;
  line-height: 1;
  cursor: pointer;
}

.gmFilters:has(.sit-dp__pop) {
  z-index: 20000;
}

.gmDateRange .sit-dp__pop {
  z-index: 20001;
  position: fixed;
  top: 50%;
  right: auto;
  bottom: auto;
  left: 50%;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 32px);
  transform: translate(-50%, -50%);
  overflow: hidden;
  overscroll-behavior: contain;
  align-items: stretch;
  animation: none;
}

.gmDateRange .sit-dp__pop > div:last-child {
  min-width: 0;
  min-height: 0;
  max-height: calc(100vh - 32px);
  display: flex;
  flex-direction: column;
}

.gmDateRange .sit-dp__pop > div:last-child > div:first-child {
  min-height: 0;
  overflow: auto;
  overscroll-behavior: contain;
}

.gmDateRange .sit-dp__pop > div:last-child > div:last-child {
  flex: 0 0 auto;
  padding: 0 14px 14px !important;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
  box-shadow: 0 -8px 16px rgba(15, 23, 42, 0.08);
}

.gmDateRange .sit-cal__foot {
  position: static;
  margin: 0;
  padding-top: 12px;
}

.gmFilterDateField {
  width: 100%;
  display: flex;
  align-items: stretch;
  flex-direction: column;
  gap: 6px;
}

.gmFilterDateField > span {
  width: 100%;
  margin: 0;
  color: #475467;
  display: block;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  text-align: left;
}

.gmColumns {
  position: relative;
}

.gmColumnsButton svg {
  width: 17px;
  height: 17px;
}

.gmColumnsButton {
  height: 38px !important;
  min-height: 38px !important;
}

.gmColumnsMenu input {
  width: 16px;
  height: 16px;
  accent-color: var(--action-primary, #227ebd);
}

.gmColumnsButton > span {
  min-width: 22px;
  height: 20px;
  padding: 0 6px;
  border-radius: 999px;
  background: #eef2f6;
  color: #667085;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 800;
}

.gmColumnsMenu {
  position: absolute;
  top: calc(100% + 7px);
  right: 0;
  z-index: 80;
  width: 230px;
  padding: 8px;
  border: 1px solid #dbe3ec;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.16);
}

.gmColumnsMenu > div {
  padding: 5px 7px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #334155;
  font-size: 12px;
}

.gmColumnsMenu > div button {
  border: 0;
  background: transparent;
  color: #1a6da3;
  font-size: 12px;
  font-weight: 700;
}

.gmColumnsMenu > label {
  min-height: 34px;
  margin: 0;
  padding: 0 7px;
  border-radius: 7px;
  display: flex;
  align-items: center;
  gap: 9px;
  color: #334155;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.gmColumnsMenu > label:hover {
  background: #f8fafc;
}

.gmColumnsMenu > label.is-required {
  color: #64748b;
  cursor: default;
}

.gmColumnsMenu > label.is-required:hover {
  background: transparent;
}

.gmColumnsMenu input:disabled {
  opacity: 0.65;
  cursor: default;
}

.gmSearch input {
  min-width: 0;
  flex: 1;
  border: 0;
  outline: none;
  background: transparent;
  width: auto;
  color: #101828;
  font-size: 13px;
}

.gmSearch .gmSearch__clear {
  display: inline-flex;
  width: 24px;
  height: 24px;
  flex: none;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 7px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 18px;
  font-weight: 500;
  line-height: 1;
  cursor: pointer;
}

.gmSearch .gmSearch__clear:hover {
  background: #e2e8f0;
  color: #334155;
}

.gmSelect {
  height: 38px;
  min-width: 150px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  background: #fff;
  color: #344054;
  padding: 0 10px;
  font-size: 13px;
  font-weight: 600;
}

.gmSelectionBar {
  justify-content: flex-start;
  min-height: 0;
  padding: 10px 16px;
  border: 0;
  border-bottom: 1px solid var(--blue-100, #d4e8f6);
  border-radius: 0;
  background: var(--blue-50, #eef6fc);
  box-shadow: none;
}
.gmSelectionClear {
  padding: 0;
  border: 0;
  background: transparent;
  color: #1a6da3;
  font-size: 13px;
  font-weight: 700;
}
.gmSelectionClear:hover {
  text-decoration: underline;
}

.gmSelectionBar strong {
  margin-right: 4px;
  color: var(--blue-700, #155d8c);
  font-size: 13px;
  font-weight: 600;
}

.gmSelectionBar .gmButton {
  height: 32px;
  min-height: 32px;
  padding: 0 11px;
  font-size: 13px;
  font-weight: 600;
}

.gmTableCard {
  overflow-x: auto;
  border: 0;
  border-radius: 0;
  background: #fff;
  box-shadow: none;
}

.gmTable {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.gmTable th {
  height: 42px;
  padding: 0 14px;
  border-bottom: 1px solid #e4e7ec;
  color: #667085;
  font-size: 11px;
  font-weight: 800;
  text-align: left;
  text-transform: uppercase;
  background: #f8fafc;
}

.gmTable td {
  height: 56px;
  padding: 8px 14px;
  border-bottom: 1px solid #eef2f6;
  vertical-align: middle;
  font-size: 13px;
}

.gmTable tbody tr {
  cursor: pointer;
}

.gmTable tbody tr:hover,
.gmTable tbody tr.is-open {
  background: #f7fbfc;
}

.gmTable tbody tr.is-selected {
  background: var(--blue-50, #eef6fc);
}

.gmTable tbody tr:last-child td {
  border-bottom: 0;
}

.gmSelectCell {
  width: 44px;
  text-align: center !important;
}

.gmSelectCell input {
  width: 16px;
  height: 16px;
  accent-color: var(--action-primary, #227ebd);
}

.gmRowOpenCell {
  width: 40px;
  min-width: 40px;
  padding-right: 12px !important;
  padding-left: 4px !important;
  text-align: center !important;
}

.gmRowOpenCell span {
  display: inline-block;
  color: var(--text-subtle, #94a3b8);
  font-size: 22px;
  line-height: 1;
  opacity: 0;
  transform: translateX(-3px);
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.gmTable tbody tr:hover .gmRowOpenCell span,
.gmTable tbody tr:focus-within .gmRowOpenCell span {
  opacity: 1;
  transform: translateX(0);
}

.gmMessageCell {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 230px;
  max-width: 380px;
}

.gmMessageCell strong,
.gmDateCell strong {
  color: #101828;
  font-size: 13px;
  font-weight: 700;
}

.gmMessageCell span,
.gmDateCell span,
.gmAudience span {
  color: #667085;
  font-size: 12px;
}

.gmMessageCell span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gmChannels {
  display: flex;
  gap: 6px;
}

.gmChannel {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #f2f4f7;
  color: #cbd5e1;
  opacity: 0.5;
}

.gmChannel--sms,
.gmChannel--email {
  background: #eaf3fb;
  color: #1c5d8c;
  opacity: 1;
}
.gmChannel--push {
  background: #eaf3fb;
  color: #1c5d8c;
  opacity: 1;
}

.gmAudience {
  display: flex;
  align-items: center;
  min-width: 150px;
}

.gmAudience strong {
  display: block;
  color: #101828;
  font-size: 13px;
}

.gmDelivery {
  min-width: 150px;
}

.gmDeliveryTrack {
  position: relative;
  height: 8px;
  overflow: hidden;
  border-radius: 999px;
  background: #eef2f6;
}

.gmDeliveryTrack span {
  position: absolute;
  inset: 0 auto 0 0;
  border-radius: inherit;
}

.gmDeliveryDelivered {
  background: #bcd9c8;
}

.gmDeliveryMeta {
  display: flex;
  gap: 9px;
  margin-top: 6px;
  color: #667085;
  font-size: 11px;
  font-weight: 700;
}

.gmDeliveryMeta em {
  color: #c6283f;
  font-style: normal;
}

.gmStatusBadge {
  display: inline-flex;
  align-items: center;
  height: 26px;
  padding: 0 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
  text-transform: capitalize;
}

.gmStatusBadge--sent {
  background: #e8f6ee;
  color: #25784a;
}
.gmStatusBadge--scheduled {
  background: #e7f2fb;
  color: #1f5f86;
}
.gmStatusBadge--draft {
  background: #f2f4f7;
  color: #475467;
}

.gmDateCell {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 150px;
}

.gmFooter {
  min-height: 58px;
  justify-content: space-between;
  padding: 12px 14px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 0 0 11px 11px;
  background: var(--surface-card, #fff);
  color: #667085;
  font-size: 13px;
  font-weight: 600;
}
.gmFooter__pages {
  display: flex;
  align-items: center;
  gap: 5px;
}
.gmFooter button {
  display: inline-flex;
  min-width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  background: #fff;
  color: #475467;
  font-size: 12px;
  font-weight: 700;
}
.gmFooter button:hover:not(:disabled) {
  border-color: #6fb1df;
  background: #eef6fc;
  color: #155d8c;
}

.gmFooter button.is-active {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}
.gmFooter button:disabled {
  opacity: 0.48;
  cursor: default;
}
.gmFooter i {
  color: #98a2b3;
  font-style: normal;
}

.gmDrawer {
  position: fixed;
  top: 76px;
  right: 18px;
  bottom: 18px;
  z-index: 80;
  width: min(520px, calc(100vw - 36px));
  overflow: auto;
  border: 1px solid #d9e2ea;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 28px 70px rgba(15, 23, 42, 0.22);
  padding: 18px;
}

.gmDetailsBackdrop {
  position: fixed;
  inset: 0;
  z-index: 5000;
  display: flex;
  align-items: stretch;
  justify-content: flex-end;
  padding: 0;
  background: rgba(15, 23, 42, 0.3);
}

.gmDetailsModal {
  display: flex;
  flex-direction: column;
  width: min(720px, calc(100vw - 24px));
  height: 100%;
  overflow: hidden;
  border: 0;
  border-left: 1px solid #d9e2ea;
  border-radius: 0;
  background: #fff;
  box-shadow: -18px 0 48px rgba(15, 23, 42, 0.22);
}

.gmDetailsHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding: 18px 22px 16px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: linear-gradient(135deg, #ffffff 0%, #f7fbfe 72%, #eef6fc 100%);
}

.gmSentScopes button span {
  display: inline-flex;
  min-width: 19px;
  height: 19px;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
  border-radius: 999px;
  background: rgba(100, 116, 139, 0.12);
  color: inherit;
  font-size: 10px;
  font-weight: 800;
}

.gmSentScopes button.is-active span {
  background: var(--blue-50, #eef6fc);
}

.gmDetailsHeader > div:first-child {
  min-width: 0;
  flex: 1 1 auto;
}

.gmDetailsHeader h2 {
  margin: 8px 0 2px;
  color: #101828;
  font-size: 20px;
  line-height: 1.25;
}

.gmDetailsHeader p {
  margin: 0;
  color: #667085;
  font-size: 12.5px;
}

.gmDetailsHeaderChips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 12px;
}

.gmDetailsHeaderChip {
  display: inline-flex;
  min-height: 25px;
  align-items: center;
  gap: 5px;
  padding: 0 9px;
  border: 1px solid transparent;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 750;
  line-height: 1.2;
  white-space: nowrap;
}

.gmDetailsHeaderChip svg {
  width: 13px;
  height: 13px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
}

.gmDetailsHeaderChip.is-recipient {
  border-color: #cfe3f3;
  background: #eef6fc;
  color: #155d8c;
}

.gmDetailsHeaderChip.is-priority {
  border-color: #ffe2a8;
  background: #fff6e6;
  color: #8a4c08;
}

.gmDetailsHeaderChip.is-channel {
  border-color: #ddd6fe;
  background: #f5f3ff;
  color: #6d4bc3;
}

.gmDetailsHeaderChip.is-ready {
  border-color: #bfe7d0;
  background: #eaf8f0;
  color: #207449;
}

.gmDetailsHeaderChip.is-incomplete {
  border-color: #fed7aa;
  background: #fff7ed;
  color: #a04b0c;
}

.gmDetailsTabs {
  display: flex;
  gap: 22px;
  padding: 0 22px;
  border-bottom: 1px solid #e4e7ec;
}

.gmDetailsTabs button {
  height: 42px;
  padding: 0 1px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: #667085;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.gmDetailsTabs button.is-active {
  border-bottom-color: #227ebd;
  color: #155d8c;
}

.gmDetailsBody {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  padding: 22px;
  background: #f8fafc;
}

.gmMetricChips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 18px;
}

.gmMetricChips span {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-height: 29px;
  padding: 0 10px;
  border-radius: 999px;
  background: #eef2f6;
  color: #475467;
  font-size: 11.5px;
  font-weight: 700;
}

.gmMetricChips span.is-success {
  background: #e8f6ee;
  color: #25784a;
}

.gmMetricChips span.is-danger {
  background: #fdecef;
  color: #a8253a;
}

.gmDetailsGrid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.gmDetailsGrid > div,
.gmAffected > div {
  padding: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 11px;
  background: #fff;
}

.gmDetailsGrid span,
.gmAffected span {
  display: block;
  margin-bottom: 5px;
  color: #667085;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
}

.gmDetailsGrid strong,
.gmAffected strong {
  color: #101828;
  font-size: 13px;
}

.gmDeliveryStats {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  min-height: 390px;
}

.gmDeliveryLoading {
  min-width: 116px;
  min-height: 18px;
  border-radius: 5px;
  background: linear-gradient(90deg, #eef2f6 25%, #f8fafc 50%, #eef2f6 75%);
  background-size: 200% 100%;
  color: #64748b;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  animation: gmDeliveryLoading 1.2s ease-in-out infinite;
}

@keyframes gmDeliveryLoading {
  from {
    background-position: 100% 0;
  }
  to {
    background-position: -100% 0;
  }
}

.gmDeliveryChannelTabs {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
}

.gmDeliveryStatsToolbar {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  position: relative;
}

.gmDeliveryRefresh {
  position: absolute;
  right: 0;
  display: inline-flex;
  height: 36px;
  padding: 0 13px;
  align-items: center;
  gap: 7px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  background: #fff;
  color: #344054;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.gmDeliveryRefresh:hover {
  border-color: #98a2b3;
  background: #f8fafc;
}

.gmDeliveryRefresh svg {
  width: 16px;
  height: 16px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.9;
}

.gmDeliveryChannelTabs button {
  padding: 7px 14px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #667085;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.gmDeliveryChannelTabs button.is-active {
  background: #fff;
  color: #245f91;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.12);
}

.gmDeliveryChart {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 56px;
}

.gmDonut {
  width: 230px;
  height: 230px;
  padding: 31px;
  border-radius: 50%;
}

.gmDonut > div {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 50%;
  background: #fff;
  box-shadow: inset 0 0 0 1px #e2e8f0;
}

.gmDonut strong {
  color: #101828;
  font-size: 30px;
}

.gmDonut span {
  color: #667085;
  font-size: 12px;
}

.gmDonutLegend {
  display: grid;
  gap: 12px;
  min-width: 230px;
}

.gmDonutLegend span {
  display: grid;
  grid-template-columns: 10px 1fr auto;
  align-items: center;
  gap: 9px;
  color: #475467;
  font-size: 13px;
}

.gmDonutLegend i {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.gmDonutLegend i.is-delivered {
  background: #35a66f;
}
.gmDonutLegend i.is-sent {
  background: #3478c5;
}
.gmDonutLegend i.is-failed {
  background: #d6455d;
}
.gmDonutLegend i.is-unavailable {
  background: #9aa8b5;
}
.gmDonutLegend i.is-pending {
  background: #dce5ec;
}

.gmContentTab {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 18px;
  padding: 4px 0 18px;
}

.gmLaptop {
  width: min(620px, calc(100% - 8px));
  margin: 0 auto;
}

.gmLaptopLid {
  position: relative;
  padding: 11px 11px 12px;
  border-radius: 16px 16px 8px 8px;
  background: #1e293b;
  box-shadow: 0 20px 42px rgba(15, 23, 42, 0.2);
}

.gmLaptopCamera {
  position: absolute;
  top: 4px;
  left: 50%;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #64748b;
  transform: translateX(-50%);
}

.gmLaptopBar {
  display: flex;
  height: 34px;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  border-radius: 8px 8px 0 0;
  background: #e8edf3;
  position: relative;
}

.gmLaptopBar span {
  color: #64748b;
  font-size: 10.5px;
  font-weight: 700;
}

.gmLaptopWindowControls {
  position: absolute;
  left: 11px;
  display: flex;
  gap: 5px;
}

.gmLaptopWindowControls i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #f87171;
}

.gmLaptopWindowControls i:nth-child(2) {
  background: #fbbf24;
}

.gmLaptopWindowControls i:nth-child(3) {
  background: #4ade80;
}

.gmLaptopScreen {
  min-height: 350px;
  max-height: 440px;
  overflow: auto;
  padding: 22px;
  border-radius: 0 0 5px 5px;
  background: linear-gradient(180deg, #f8fafc 0%, #edf2f7 100%);
}

.gmEmailMockup {
  width: min(470px, 100%);
  min-height: 290px;
  margin: 0 auto;
  overflow: hidden;
  border: 1px solid #dbe4ee;
  border-radius: 11px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}

.gmEmailMockup > header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  background: var(--brand-navy, #164170);
  color: #fff;
}

.gmEmailMockupLogo {
  display: inline-flex;
  width: 32px;
  height: 32px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: var(--brand-orange, #f26522);
  color: #fff;
  font-size: 16px;
  font-weight: 850;
}

.gmEmailMockup > header strong,
.gmEmailMockup > header span {
  display: block;
}

.gmEmailMockup > header strong {
  font-size: 13px;
}

.gmEmailMockup > header span {
  margin-top: 2px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 10px;
}

.gmEmailMockupBody {
  padding: 22px 24px 28px;
}

.gmPreviewEyebrow {
  display: block;
  margin-bottom: 5px;
  color: #64748b;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.gmEmailMockupBody h3 {
  margin: 0 0 18px;
  color: #0f172a;
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 19px;
  line-height: 1.3;
}

.gmEmailMockupBody p {
  margin: 0;
  color: #334155;
  font-size: 12px;
  line-height: 1.65;
  white-space: pre-wrap;
}

.gmPreviewEmpty {
  padding: 28px 18px;
  border: 1px dashed #cbd5e1;
  border-radius: 9px;
  background: #f8fafc;
  color: #94a3b8;
  font-size: 12px;
  font-weight: 650;
  text-align: center;
}

.gmLaptopBase {
  position: relative;
  width: calc(100% + 48px);
  height: 14px;
  margin-left: -24px;
  border-radius: 2px 2px 16px 16px;
  background: linear-gradient(180deg, #dbe2ea 0%, #aeb8c4 100%);
  box-shadow: 0 10px 18px rgba(15, 23, 42, 0.15);
}

.gmLaptopBase span {
  position: absolute;
  top: 0;
  left: 50%;
  width: 72px;
  height: 5px;
  border-radius: 0 0 6px 6px;
  background: #8f9aa7;
  transform: translateX(-50%);
}

.gmAffected {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.gmAffected em {
  display: block;
  margin-top: 7px;
  color: #667085;
  font-size: 12px;
  font-style: normal;
}

.gmAffected .gmAffectedTotal {
  border-color: #cfe1f2;
  background: #eef6fc;
}

.gmAffected .gmAffectedRole {
  border-color: #e2e8f0;
  background: #fff;
}

.gmAffectedTotal strong {
  font-size: 24px;
  color: #155d8c;
}

.gmAffected .gmAffectedDelivery {
  grid-column: span 2;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  column-gap: 18px;
}

.gmAffectedDelivery > span,
.gmAffectedDelivery > strong,
.gmAffectedDelivery > em {
  grid-column: 1;
}

.gmAffectedDelivery > button {
  grid-column: 2;
  grid-row: 1 / span 3;
}

.gmDetailsActions {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 22px;
  border-top: 1px solid #e4e7ec;
  background: #fafbfc;
}

.gmDrawerHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.gmDrawerTitleRow {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
}

.gmDrawerIcon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}

.gmDrawerIcon svg {
  width: 20px;
  height: 20px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.gmDrawerIcon--sms {
  background: #e8f6ee;
  color: #2f9e5a;
}
.gmDrawerIcon--email {
  background: #e7f2fb;
  color: #227ebd;
}
.gmDrawerIcon--push {
  background: #f0edfb;
  color: #7b5bd6;
}

.gmDrawerHeader h2 {
  margin: 8px 0 5px;
  color: #101828;
  font-size: 20px;
  line-height: 1.25;
  font-weight: 800;
  letter-spacing: 0;
}

.gmDrawerHeader p {
  margin: 0;
  color: #667085;
  font-size: 12.5px;
  line-height: 1.4;
}

.gmIconButton {
  width: 34px;
  height: 34px;
  padding: 0;
  border-color: #d0d5dd;
  background: #fff;
  color: #475467;
}

.gmDrawerPanel {
  padding: 14px 15px;
  border-radius: 12px;
  border: 1px solid #d9e2ea;
  margin-bottom: 16px;
}

.gmDrawerPanel--sent {
  background: #f7fbfc;
  border-color: #cfe1e8;
}
.gmDrawerPanel--scheduled {
  background: #e9f1fa;
  border-color: #cfe1f2;
}
.gmDrawerPanel--draft {
  background: #f8fafc;
  border-color: #e4e7ec;
}

.gmDrawerPanelHeader {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.gmDrawerPanelHeader span,
.gmDrawerSectionTitle {
  color: #667085;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.gmDrawerPanelHeader strong {
  color: #101828;
  font-size: 14px;
  font-weight: 800;
}

.gmDrawerPanel p {
  margin: 10px 0 0;
  color: #475467;
  font-size: 12.5px;
  line-height: 1.5;
}

.gmFunnel {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-bottom: 10px;
}

.gmFunnel--four {
  grid-template-columns: repeat(4, 1fr);
}

.gmFunnel div {
  padding: 9px 10px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #e4e7ec;
}

.gmFunnel span {
  display: block;
  color: #667085;
  font-size: 11px;
  font-weight: 700;
}

.gmFunnel strong {
  display: block;
  margin-top: 3px;
  color: #101828;
  font-size: 18px;
  font-weight: 800;
}

.gmDrawerProgress {
  height: 8px;
  overflow: hidden;
  border-radius: 999px;
  background: #e4e7ec;
}

.gmDrawerProgress span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #227ebd;
}

.gmDrawerSectionTitle {
  margin: 2px 0 10px;
}

.gmDrawerChannels {
  display: inline-flex;
  gap: 4px;
  padding: 4px;
  border-radius: 12px;
  border: 1px solid #d9e2ea;
  background: #f8fafc;
  margin-bottom: 16px;
}

.gmDrawerChannels button {
  height: 32px;
  border: 0;
  border-radius: 9px;
  background: transparent;
  color: #667085;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 0 12px;
  font-size: 13px;
  font-weight: 700;
}

.gmDrawerChannels button.is-active {
  background: #fff;
  color: #174f64;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.12);
}

.gmPhoneFrame {
  width: 286px;
  margin: 0 auto;
  padding: 10px;
  border: 1px solid #0f172a;
  border-radius: 42px;
  background: linear-gradient(145deg, #263449, #0b1220);
  box-shadow: 0 24px 48px rgba(15, 23, 42, 0.28), inset 0 0 0 1px rgba(255, 255, 255, 0.1);
}

.gmPhoneScreen {
  position: relative;
  height: 500px;
  overflow: hidden;
  border-radius: 33px;
  display: flex;
  flex-direction: column;
}

.gmPhoneScreen::before {
  content: '';
  position: absolute;
  top: 7px;
  left: 50%;
  width: 74px;
  height: 20px;
  border-radius: 999px;
  transform: translateX(-50%);
  background: #101828;
  z-index: 2;
}

.gmPhoneScreen--sms {
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  padding: 40px 14px 18px;
}
.gmPhoneScreen--email {
  background: #fff;
  padding-top: 34px;
}
.gmPhoneScreen--push {
  background: radial-gradient(circle at 72% 18%, rgba(92, 153, 203, 0.72), transparent 35%),
    linear-gradient(160deg, #334e68, #101a2c 72%);
  padding: 42px 12px 18px;
  color: #fff;
}

.gmPhoneStatusBar {
  position: absolute;
  top: 10px;
  right: 16px;
  left: 16px;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #0f172a;
  font-size: 9px;
  font-weight: 800;
}

.gmPhoneScreen--push .gmPhoneStatusBar {
  color: #fff;
}

.gmPhoneStatusBar > div {
  display: flex;
  align-items: flex-end;
  gap: 3px;
}

.gmPhoneStatusBar i {
  display: block;
  width: 3px;
  height: 5px;
  border-radius: 1px;
  background: currentColor;
}

.gmPhoneStatusBar i:nth-child(2) {
  height: 7px;
}

.gmPhoneStatusBar i:nth-child(3) {
  width: 9px;
  height: 6px;
  border-radius: 2px;
}

.gmPhoneTop {
  margin: 0 -14px 14px;
  padding: 10px 14px 13px;
  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
  text-align: center;
  color: #101828;
  font-size: 12.5px;
  font-weight: 800;
}

.gmConversationDate {
  display: block;
  margin: 2px 0 12px;
  color: #94a3b8;
  font-size: 9px;
  font-weight: 750;
  text-align: center;
  text-transform: uppercase;
}

.gmSmsBubble {
  max-width: 82%;
  margin: 0;
  padding: 10px 13px;
  border-radius: 18px 18px 18px 5px;
  background: #e7e9ee;
  color: #101828;
  font-size: 13px;
  line-height: 1.5;
  white-space: pre-wrap;
}

.gmSmsBubble.is-empty {
  border: 1px dashed #cbd5e1;
  background: rgba(255, 255, 255, 0.72);
  color: #94a3b8;
}

.gmEmailBar {
  display: flex;
  align-items: center;
  min-height: 40px;
  padding: 0 15px;
  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
  color: #101828;
  font-size: 12.5px;
  font-weight: 800;
}

.gmEmailPreview {
  flex: 1;
  overflow: auto;
  border: 0;
  border-radius: 0;
  background: #fff;
  padding: 15px;
  color: #334155;
}

.gmEmailPreview strong {
  display: block;
  color: #101828;
  font-size: 16px;
  line-height: 1.3;
  margin-bottom: 10px;
}

.gmEmailPreview span {
  display: block;
  color: #64748b;
  font-size: 11px;
  margin-bottom: 12px;
}

.gmEmailPreview p {
  margin: 0;
  color: #334155;
  font-size: 13px;
  line-height: 1.6;
  white-space: pre-wrap;
}

.gmPushClock {
  text-align: center;
  font-size: 56px;
  line-height: 1;
  font-weight: 300;
  margin-top: 18px;
  margin-bottom: auto;
}

.gmPushClock span {
  display: block;
  margin-top: 7px;
  font-size: 11px;
  font-weight: 650;
}

.gmPushPreview {
  display: flex;
  gap: 10px;
  padding: 11px 12px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.92);
  color: #334155;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.22);
  margin-bottom: 18px;
}

.gmPushAppIcon {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  background: #7b5bd6;
  color: #fff;
}

.gmPushPreview span {
  display: block;
  color: #0e1726;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
}

.gmPushPreview strong {
  display: block;
  color: #101828;
  font-size: 13.5px;
  margin-top: 2px;
}

.gmPushPreview p {
  margin: 2px 0 0;
  color: #334155;
  font-size: 12.5px;
  line-height: 1.45;
}

.gmPhoneHomeIndicator {
  position: absolute;
  bottom: 7px;
  left: 50%;
  width: 86px;
  height: 4px;
  border-radius: 999px;
  background: currentColor;
  opacity: 0.68;
  transform: translateX(-50%);
}

.gmDrawerActions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 16px;
}

.gmEmpty {
  padding: 44px 20px;
  text-align: center;
  color: #667085;
}

.gmEmpty svg {
  width: 34px;
  height: 34px;
  margin-bottom: 10px;
}

.gmEmpty h2 {
  margin: 0 0 5px;
  color: #101828;
  font-size: 18px;
}

.gmEmpty p {
  margin: 0;
}

.gmModalBackdrop {
  position: fixed;
  inset: 0;
  z-index: 100;
  background: rgba(15, 23, 42, 0.42);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.gmModal {
  width: min(440px, 100%);
  border-radius: 16px;
  background: #fff;
  padding: 22px;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.25);
}

.gmModalIcon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fde8ec;
  color: #c6283f;
  margin-bottom: 14px;
}

.gmModalIcon svg {
  width: 22px;
  height: 22px;
}

.gmModal h2 {
  margin: 0 0 8px;
  color: #101828;
  font-size: 20px;
  font-weight: 800;
}

.gmModal p {
  margin: 0;
  color: #667085;
  font-size: 13px;
  line-height: 1.5;
}

.gmModalActions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 20px;
}

.gmCopyModal {
  width: min(520px, 100%);
}

.gmScheduleActionModal {
  width: min(480px, 100%);
}

.gmScheduleActionModal__heading {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
}

.gmScheduleActionModal__heading > div {
  min-width: 0;
}

.gmScheduleActionModal__heading h2 {
  margin-bottom: 4px;
}

.gmScheduleActionModal__heading p {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gmScheduleActionModal__icon {
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-600, #1a6da3);
}

.gmScheduleActionModal__icon svg {
  width: 20px;
  height: 20px;
}

.gmScheduleActionModal__description {
  margin-top: 16px !important;
  padding: 12px 14px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 10px;
  background: var(--surface-page, #f8fafc);
  color: var(--text-body, #334155) !important;
}

.gmScheduleActionModal__field {
  margin-top: 18px;
}

.gmScheduleActionModal__field .gmScheduleDateTimePicker {
  width: 100%;
}

.gmScheduleActionModal__error {
  margin-top: 12px;
  padding: 9px 11px;
  border-radius: 8px;
  background: #fff1f3;
  color: #b4233b;
  font-size: 12.5px;
  font-weight: 600;
}

.gmCopyModal__heading {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
}

.gmCopyModal__heading > div {
  min-width: 0;
}

.gmCopyModal__heading h2 {
  margin-bottom: 4px;
}

.gmCopyModal__heading p {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gmCopyModal__icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  background: #eef6fc;
  color: #227ebd;
}

.gmCopyModal__icon svg {
  width: 19px;
  height: 19px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.gmCopyOptions {
  display: grid;
  gap: 8px;
  margin-top: 18px;
}

.gmCopyOption {
  position: relative;
  display: grid;
  grid-template-columns: 20px minmax(0, 1fr);
  align-items: center;
  gap: 11px;
  min-height: 58px;
  margin: 0;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}

.gmCopyOption:hover {
  border-color: #93bddd;
  background: #fafcff;
}

.gmCopyOption.is-selected {
  border-color: #7eb3d8;
  background: #eef6fc;
  box-shadow: inset 3px 0 0 #227ebd;
}

.gmCopyOption input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}

.gmCopyOption__check {
  width: 18px;
  height: 18px;
  border: 1px solid #cbd5e1;
  border-radius: 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  color: transparent;
  font-size: 12px;
  font-weight: 800;
  line-height: 1;
}

.gmCopyOption.is-selected .gmCopyOption__check {
  border-color: #227ebd;
  background: #227ebd;
  color: #fff;
}

.gmCopyOption strong,
.gmCopyOption small {
  display: block;
}

.gmCopyOption strong {
  color: #0f172a;
  font-size: 13px;
  font-weight: 750;
}

.gmCopyOption small {
  margin-top: 2px;
  color: #64748b;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.35;
}

.gmCopyModal__error {
  margin-top: 10px;
  color: #b42318;
  font-size: 12px;
  font-weight: 650;
}

.gmToast {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 120;
  padding: 11px 14px;
  border-radius: 10px;
  background: #101828;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  box-shadow: 0 16px 34px rgba(15, 23, 42, 0.24);
}

@media (max-width: 1217px) {
  .gmPageHeader {
    width: 100vw;
    margin-left: -12px;
    padding-right: 28px;
  }
}

@media (max-width: 900px) {
  .gmPage {
    padding: 0 0 24px;
  }
  .gmPageHeader {
    width: 100vw;
    height: auto;
    min-height: 70px;
    flex-wrap: wrap;
    gap: 0 16px;
    margin: -16px 0 14px -16px;
    padding: 10px 16px 0;
  }
  .gmPageHeader h1 {
    overflow: hidden;
    font-size: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .gmPageHeader > .gmButton {
    margin-left: auto;
  }
  .gmHeader,
  .gmSelectionBar {
    align-items: stretch;
    flex-direction: column;
  }
  .gmTabs {
    width: 100%;
    height: 42px;
    flex-basis: 100%;
    order: 3;
  }
  .gmTabs button {
    flex: 0 0 auto;
  }
  .gmToolbar {
    display: grid;
    grid-template-columns: auto auto minmax(0, 1fr);
    min-height: 0;
    align-items: center;
    justify-content: initial;
    gap: 8px;
    padding: 10px 12px;
  }
  .gmSearch {
    grid-column: 1 / -1;
    width: 100%;
    max-width: none;
    flex: none;
  }
  .gmSelect {
    width: 100%;
  }
  .gmFilterButton {
    grid-column: 1;
  }
  .gmColumns {
    grid-column: 2;
  }
  .gmColumnsButton > span {
    display: none;
  }
  .gmToolbarSpacer {
    display: none;
  }
  .gmSentScopes {
    grid-column: 3;
    justify-self: end;
    align-self: center;
  }
  .gmFilters {
    position: fixed;
    top: 66px;
    right: 0;
    bottom: 0;
    left: auto;
    z-index: 1200;
    width: min(360px, 100%);
    max-height: none;
    overflow-y: auto;
    padding: 18px 16px max(18px, env(safe-area-inset-bottom));
    border-radius: 0;
    box-shadow: -12px 0 34px rgba(15, 23, 42, 0.2);
  }
  .gmFiltersActions {
    position: sticky;
    bottom: 0;
    margin: 0 -16px -18px;
    padding: 14px 16px max(14px, env(safe-area-inset-bottom));
    background: #fff;
  }
  .gmTableCard {
    overflow-x: auto;
  }
  .gmTable {
    width: 100%;
  }
  .gmFooter {
    align-items: flex-start;
    flex-direction: column;
  }
  .gmFooter__pages {
    max-width: 100%;
    overflow-x: auto;
  }
  .gmDrawer {
    top: 64px;
    right: 10px;
    bottom: 10px;
    width: calc(100vw - 20px);
  }
  .gmDetailsBackdrop {
    inset: 0;
    padding: 0;
  }
  .gmDetailsModal {
    width: min(100%, 720px);
    height: 100%;
  }
  .gmDetailsTabs {
    overflow-x: auto;
  }
  .gmDetailsTabs button {
    flex: 0 0 auto;
  }
  .gmDetailsHeader {
    padding: 15px 16px 14px;
  }
  .gmDetailsHeaderChips {
    max-height: 62px;
    overflow-y: auto;
  }
  .gmDetailsBody {
    padding: 16px;
  }
  .gmLaptop {
    width: calc(100% - 24px);
  }
  .gmLaptopScreen {
    min-height: 310px;
    padding: 14px;
  }
  .gmLaptopBase {
    width: calc(100% + 28px);
    margin-left: -14px;
  }
  .gmDetailsGrid,
  .gmAffected {
    grid-template-columns: 1fr;
  }
  .gmAffected .gmAffectedDelivery {
    grid-column: 1;
    grid-template-columns: 1fr;
  }
  .gmAffectedDelivery > button {
    grid-column: 1;
    grid-row: auto;
    margin-top: 12px;
  }
  .gmDeliveryStats {
    flex-direction: column;
    gap: 26px;
  }
  .gmDetailsActions {
    align-items: stretch;
    flex-direction: column;
    overflow-y: auto;
  }
}

@media (max-width: 340px) {
  .gmToolbar {
    grid-template-columns: auto minmax(0, 1fr);
  }
  .gmSentScopes {
    grid-column: 1 / -1;
    justify-self: start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminView/Communications/GeneralMessages/GeneralMessages.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,8BAA8B;EAC9B,wBAAwB;EACxB,iBAAiB;EACjB,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,0BAA0B;EAC1B,sBAAsB;EACtB,sDAAsD;EACtD,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,SAAS;EACT,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+CAA+C;EAC/C,qCAAqC;EACrC,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;;;;EAIE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;AACjB;;AAEA;;EAEE,6BAA6B;EAC7B,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kFAAkF;AACpF;;AAEA;;;;;;;EAOE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,gDAAgD;EAChD,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,0CAA0C;EAC1C,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,sDAAsD;EACtD,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;AACA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,UAAU;EACV,aAAa;EACb,aAAa;EACb,qCAAqC;EACrC,sBAAsB;EACtB,MAAM;EACN,oBAAoB;EACpB,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,sDAAsD;AACxD;;AAEA;EACE,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,gDAAgD;EAChD,kBAAkB;EAClB,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,gCAAgC;EAChC,qEAAqE;AACvE;;AAEA;EACE,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,QAAQ;EACR,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,6BAA6B;EAC7B,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;EAChB,4BAA4B;EAC5B,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,mDAAmD;EACnD,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,SAAS;EACT,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,iDAAiD;EACjD,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gCAAgC;EAChC,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,eAAe;EACf,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,eAAe;EACf,cAAc;EACd,UAAU;EACV,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA;;EAEE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;EAClB,mDAAmD;EACnD,4BAA4B;EAC5B,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,YAAY;EACZ,WAAW;EACX,qCAAqC;EACrC,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,oBAAoB;EACpB,yBAAyB;EACzB,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,sDAAsD;EACtD,0EAA0E;AAC5E;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,sDAAsD;AACxD;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,0BAA0B;EAC1B,6DAA6D;AAC/D;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yEAAyE;EACzE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,6DAA6D;EAC7D,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,qDAAqD;EACrD,wFAAwF;AAC1F;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,6DAA6D;EAC7D,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE;iDAC+C;EAC/C,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,+CAA+C;EAC/C,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,+CAA+C;EAC/C,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,wBAAwB;EACxB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iFAAiF;AACnF;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,0BAA0B;IAC1B,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,oBAAoB;IACpB,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,QAAQ;EACV;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;IACb,+CAA+C;IAC/C,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,QAAQ;IACR,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,SAAS;IACT,QAAQ;IACR,SAAS;IACT,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,yDAAyD;IACzD,gBAAgB;IAChB,8CAA8C;EAChD;EACA;IACE,gBAAgB;IAChB,SAAS;IACT,qBAAqB;IACrB,yDAAyD;IACzD,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,yBAAyB;EAC3B;EACA;IACE,QAAQ;IACR,UAAU;EACZ;EACA;IACE,uBAAuB;IACvB,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,wBAAwB;IACxB,kBAAkB;EACpB;EACA;;IAEE,0BAA0B;EAC5B;EACA;IACE,cAAc;IACd,0BAA0B;EAC5B;EACA;IACE,cAAc;IACd,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;AACF","sourcesContent":[".gmPage {\n  position: relative;\n  width: 100%;\n  min-height: calc(100vh - 76px);\n  margin-top: 0 !important;\n  padding: 0 0 32px;\n  background: var(--surface-page, #f8fafc);\n  color: var(--text-body, #334155);\n}\n\n.gmShell {\n  position: relative;\n  width: 100%;\n  max-width: none;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.gmPageHeader {\n  display: flex;\n  width: calc(100% + 48px);\n  height: 70px;\n  min-height: 70px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 18px;\n  margin: -20px 0 18px -24px;\n  padding: 0 72px 0 28px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n\n.gmPageHeader h1 {\n  flex: 0 0 auto;\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 22px;\n  font-weight: 800;\n  line-height: 1.1;\n  letter-spacing: -0.015em;\n  white-space: nowrap;\n}\n\n.gmListCard {\n  overflow: visible;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-lg, 12px);\n  background: var(--surface-card, #fff);\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.gmHeader,\n.gmToolbar,\n.gmSelectionBar,\n.gmFooter {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.gmHeader h1 {\n  margin: 0;\n  font-size: 24px;\n  line-height: 1.2;\n  font-weight: 700;\n  color: var(--text-strong, #101828);\n  letter-spacing: 0;\n}\n\n.gmHeader h1 span {\n  display: inline-flex;\n  align-items: center;\n  min-width: 26px;\n  height: 24px;\n  padding: 0 8px;\n  margin-left: 8px;\n  border-radius: 999px;\n  background: #eef2f6;\n  color: #475467;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.gmHeader p {\n  margin: 5px 0 0;\n  color: var(--text-muted, #667085);\n  font-size: 13px;\n}\n\n.gmButton,\n.gmIconButton {\n  border: 1px solid transparent;\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  height: 36px;\n  padding: 0 13px;\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1;\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n}\n\n.gmButton svg,\n.gmIconButton svg,\n.gmSearch svg,\n.gmChannel svg,\n.gmDrawerChannels svg,\n.gmModalIcon svg,\n.gmEmpty svg {\n  width: 16px;\n  height: 16px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.9;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  flex: 0 0 auto;\n}\n\n.gmButton--primary {\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n  border-color: var(--action-primary, #227ebd);\n}\n\n.gmButton--primary:hover {\n  background: var(--action-primary-hover, #1a6da3);\n  border-color: var(--action-primary-hover, #1a6da3);\n}\n\n.gmCreateIcon {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 1;\n}\n\n.gmButton--secondary {\n  background: #fff;\n  color: #1f4f63;\n  border-color: #c8d7df;\n}\n\n.gmButton--secondary:hover {\n  background: #f4fafc;\n}\n\n.gmButton--ghost {\n  background: #fff;\n  color: #475467;\n  border-color: #d0d5dd;\n}\n\n.gmButton--ghost:disabled {\n  opacity: 0.55;\n  cursor: default;\n}\n\n.gmButton--danger {\n  background: var(--red-500, #da4453);\n  color: #fff;\n  border-color: transparent;\n}\n\n.gmButton--danger:hover {\n  background: var(--red-600, #c4313f);\n  box-shadow: 0 4px 12px rgba(218, 68, 83, 0.28);\n}\n\n.gmTabs {\n  display: flex;\n  min-width: 0;\n  flex: 1 1 auto;\n  align-self: stretch;\n  align-items: stretch;\n  gap: 26px;\n  overflow-x: auto;\n  margin: 0;\n  border-bottom: 0;\n}\n\n.gmTabs button {\n  position: relative;\n  display: inline-flex;\n  height: auto;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 7px;\n  border: 0;\n  background: transparent;\n  color: var(--text-muted, #64748b);\n  padding: 1px 0 0;\n  font-size: 15px;\n  font-weight: 650;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.gmTabs button.is-active {\n  color: var(--blue-600, #1a6da3);\n}\n\n.gmTabs button.is-active::after {\n  content: '';\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  height: 3px;\n  border-radius: 3px 3px 0 0;\n  background: var(--action-primary, #227ebd);\n}\n\n.gmTabs span {\n  display: inline-flex;\n  min-width: 20px;\n  height: 20px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 6px;\n  border-radius: 999px;\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.gmTabs button.is-active span {\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.gmPageHeader > .gmButton {\n  height: 40px;\n  min-height: 40px;\n  flex: 0 0 auto;\n  border-radius: var(--radius-md, 8px);\n  font-size: 14px;\n  font-weight: 650;\n}\n\n.gmSentScopes {\n  display: inline-flex;\n  width: fit-content;\n  gap: 4px;\n  padding: 4px;\n  border: 0;\n  border-radius: 10px;\n  background: var(--surface-sunken, #f1f5f9);\n}\n\n.gmSentScopes button {\n  display: inline-flex;\n  height: 30px;\n  align-items: center;\n  gap: 6px;\n  padding: 0 13px;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: #667085;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.gmSentScopes button.is-active {\n  background: #fff;\n  color: #155d8c;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.12);\n}\n\n.gmToolbar {\n  order: initial;\n  min-height: 64px;\n  justify-content: flex-start;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 12px 12px 0 0;\n  background: var(--surface-card, #fff);\n}\n\n.gmToolbarHeading {\n  flex: 0 0 auto;\n  margin: 0 6px 0 0;\n  color: var(--text-strong, #101828);\n  font-size: 24px;\n  line-height: 1.2;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.gmToolbarHeading span {\n  display: inline-flex;\n  min-width: 26px;\n  height: 24px;\n  margin-left: 8px;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: #eef2f6;\n  color: #475467;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 700;\n  vertical-align: middle;\n}\n\n.gmToolbar .gmButton {\n  height: 40px;\n  min-height: 40px;\n}\n.gmToolbarTitle {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin-right: 2px;\n}\n.gmToolbarTitle strong {\n  color: #101828;\n  font-size: 15px;\n}\n.gmToolbarTitle span {\n  display: inline-flex;\n  min-width: 24px;\n  height: 22px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 7px;\n  border-radius: 999px;\n  background: #eef2f6;\n  color: #667085;\n  font-size: 11px;\n  font-weight: 800;\n}\n.gmToolbarSpacer {\n  flex: 1;\n}\n\n.gmSearch {\n  height: 38px;\n  width: min(420px, 100%);\n  flex: 0 1 420px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 12px;\n  border: 1px solid #d0d5dd;\n  border-radius: 8px;\n  background: #fff;\n  color: #667085;\n  margin-bottom: 0;\n}\n.gmFilterButton {\n  position: relative;\n  display: inline-flex;\n  width: auto;\n  min-width: 40px;\n  height: 38px;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  padding: 0 12px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #fff;\n  color: #334155;\n  cursor: pointer;\n  font-size: 12.5px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n.gmFilterButton svg {\n  width: 18px;\n  height: 18px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n.gmFilterButton:hover,\n.gmFilterButton.is-active {\n  border-color: #6fb1df;\n  background: #eef6fc;\n  color: #155d8c;\n}\n.gmFilterButton > b {\n  position: static;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 19px;\n  height: 19px;\n  padding: 0 5px;\n  border-radius: 999px;\n  background: #227ebd;\n  color: #fff;\n  font-size: 10.5px;\n  font-weight: 800;\n}\n.gmFilters {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: auto;\n  z-index: 1200;\n  display: flex;\n  width: min(360px, calc(100vw - 20px));\n  flex-direction: column;\n  gap: 0;\n  align-items: stretch;\n  padding: 0;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  border: 0;\n  border-left: 1px solid #d9e2ec;\n  border-radius: 0;\n  background: #fff;\n  box-shadow: -12px 0 34px rgba(15, 23, 42, 0.14);\n}\n\n.gmFiltersBody {\n  display: flex;\n  min-height: 0;\n  flex: 1 1 auto;\n  flex-direction: column;\n  gap: 14px;\n  padding: 18px 18px 24px;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.gmFiltersHeader {\n  display: flex;\n  min-height: 38px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.gmFiltersHeader strong {\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 18px;\n  font-weight: 800;\n}\n\n.gmFiltersHeader button {\n  width: 32px;\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  background: var(--surface-card, #fff);\n  color: var(--text-muted, #64748b);\n  font-size: 20px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.gmFiltersHeader button:hover {\n  border-color: var(--blue-500, #227ebd);\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n.gmFilters label {\n  display: flex;\n  margin: 0;\n  flex-direction: column;\n  gap: 6px;\n}\n.gmFilters label > span {\n  color: #475467;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.gmFilters .gmInput {\n  width: 100%;\n  height: 38px;\n  padding: 0 11px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  outline: none;\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n  font: 400 13px var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n\n.gmFilters .gmInput:focus {\n  border-color: var(--blue-500, #227ebd);\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.16);\n}\n\n.gmFilterChoices {\n  min-width: 0;\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\n\n.gmFilterChoices legend {\n  margin-bottom: 7px;\n  color: #475467;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.gmFilterChoices > div {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.gmFilterChoices button {\n  height: 30px;\n  padding: 0 10px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #fff;\n  color: #334155;\n  font-size: 11.5px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.gmFilterChoices button.is-active {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n.gmFiltersActions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: auto;\n  padding-top: 14px;\n  border-top: 1px solid #e5e9f0;\n}\n\n.gmFiltersActions__spacer {\n  flex: 1 1 auto;\n}\n\n.gmFilterClear,\n.gmFilterChips__clear {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #1c5d8c;\n  font-size: 11.5px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.gmFilterClear:hover,\n.gmFilterChips__clear:hover {\n  text-decoration: underline;\n}\n\n.gmFilterChips {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 46px;\n  padding: 10px 16px;\n  flex-wrap: wrap;\n  border-bottom: 1px solid #e5e9f0;\n}\n\n.gmFilterChip {\n  display: inline-flex;\n  align-items: center;\n  min-height: 26px;\n  gap: 6px;\n  padding: 0 10px;\n  border-radius: 999px;\n  background: #eaf3fb;\n  color: #1c5d8c;\n  font-size: 11.5px;\n  font-weight: 700;\n}\n\n.gmFilterChip button {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font-size: 15px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.gmFilters:has(.sit-dp__pop) {\n  z-index: 20000;\n}\n\n.gmDateRange .sit-dp__pop {\n  z-index: 20001;\n  position: fixed;\n  top: 50%;\n  right: auto;\n  bottom: auto;\n  left: 50%;\n  max-width: calc(100vw - 32px);\n  max-height: calc(100vh - 32px);\n  transform: translate(-50%, -50%);\n  overflow: hidden;\n  overscroll-behavior: contain;\n  align-items: stretch;\n  animation: none;\n}\n\n.gmDateRange .sit-dp__pop > div:last-child {\n  min-width: 0;\n  min-height: 0;\n  max-height: calc(100vh - 32px);\n  display: flex;\n  flex-direction: column;\n}\n\n.gmDateRange .sit-dp__pop > div:last-child > div:first-child {\n  min-height: 0;\n  overflow: auto;\n  overscroll-behavior: contain;\n}\n\n.gmDateRange .sit-dp__pop > div:last-child > div:last-child {\n  flex: 0 0 auto;\n  padding: 0 14px 14px !important;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n  box-shadow: 0 -8px 16px rgba(15, 23, 42, 0.08);\n}\n\n.gmDateRange .sit-cal__foot {\n  position: static;\n  margin: 0;\n  padding-top: 12px;\n}\n\n.gmFilterDateField {\n  width: 100%;\n  display: flex;\n  align-items: stretch;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.gmFilterDateField > span {\n  width: 100%;\n  margin: 0;\n  color: #475467;\n  display: block;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 16px;\n  text-align: left;\n}\n\n.gmColumns {\n  position: relative;\n}\n\n.gmColumnsButton svg {\n  width: 17px;\n  height: 17px;\n}\n\n.gmColumnsButton {\n  height: 38px !important;\n  min-height: 38px !important;\n}\n\n.gmColumnsMenu input {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--action-primary, #227ebd);\n}\n\n.gmColumnsButton > span {\n  min-width: 22px;\n  height: 20px;\n  padding: 0 6px;\n  border-radius: 999px;\n  background: #eef2f6;\n  color: #667085;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.gmColumnsMenu {\n  position: absolute;\n  top: calc(100% + 7px);\n  right: 0;\n  z-index: 80;\n  width: 230px;\n  padding: 8px;\n  border: 1px solid #dbe3ec;\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.16);\n}\n\n.gmColumnsMenu > div {\n  padding: 5px 7px 8px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  color: #334155;\n  font-size: 12px;\n}\n\n.gmColumnsMenu > div button {\n  border: 0;\n  background: transparent;\n  color: #1a6da3;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.gmColumnsMenu > label {\n  min-height: 34px;\n  margin: 0;\n  padding: 0 7px;\n  border-radius: 7px;\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  color: #334155;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.gmColumnsMenu > label:hover {\n  background: #f8fafc;\n}\n\n.gmColumnsMenu > label.is-required {\n  color: #64748b;\n  cursor: default;\n}\n\n.gmColumnsMenu > label.is-required:hover {\n  background: transparent;\n}\n\n.gmColumnsMenu input:disabled {\n  opacity: 0.65;\n  cursor: default;\n}\n\n.gmSearch input {\n  min-width: 0;\n  flex: 1;\n  border: 0;\n  outline: none;\n  background: transparent;\n  width: auto;\n  color: #101828;\n  font-size: 13px;\n}\n\n.gmSearch .gmSearch__clear {\n  display: inline-flex;\n  width: 24px;\n  height: 24px;\n  flex: none;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 0;\n  border-radius: 7px;\n  background: #f1f5f9;\n  color: #64748b;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.gmSearch .gmSearch__clear:hover {\n  background: #e2e8f0;\n  color: #334155;\n}\n\n.gmSelect {\n  height: 38px;\n  min-width: 150px;\n  border: 1px solid #d0d5dd;\n  border-radius: 8px;\n  background: #fff;\n  color: #344054;\n  padding: 0 10px;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.gmSelectionBar {\n  justify-content: flex-start;\n  min-height: 0;\n  padding: 10px 16px;\n  border: 0;\n  border-bottom: 1px solid var(--blue-100, #d4e8f6);\n  border-radius: 0;\n  background: var(--blue-50, #eef6fc);\n  box-shadow: none;\n}\n.gmSelectionClear {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #1a6da3;\n  font-size: 13px;\n  font-weight: 700;\n}\n.gmSelectionClear:hover {\n  text-decoration: underline;\n}\n\n.gmSelectionBar strong {\n  margin-right: 4px;\n  color: var(--blue-700, #155d8c);\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.gmSelectionBar .gmButton {\n  height: 32px;\n  min-height: 32px;\n  padding: 0 11px;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.gmTableCard {\n  overflow-x: auto;\n  border: 0;\n  border-radius: 0;\n  background: #fff;\n  box-shadow: none;\n}\n\n.gmTable {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\n.gmTable th {\n  height: 42px;\n  padding: 0 14px;\n  border-bottom: 1px solid #e4e7ec;\n  color: #667085;\n  font-size: 11px;\n  font-weight: 800;\n  text-align: left;\n  text-transform: uppercase;\n  background: #f8fafc;\n}\n\n.gmTable td {\n  height: 56px;\n  padding: 8px 14px;\n  border-bottom: 1px solid #eef2f6;\n  vertical-align: middle;\n  font-size: 13px;\n}\n\n.gmTable tbody tr {\n  cursor: pointer;\n}\n\n.gmTable tbody tr:hover,\n.gmTable tbody tr.is-open {\n  background: #f7fbfc;\n}\n\n.gmTable tbody tr.is-selected {\n  background: var(--blue-50, #eef6fc);\n}\n\n.gmTable tbody tr:last-child td {\n  border-bottom: 0;\n}\n\n.gmSelectCell {\n  width: 44px;\n  text-align: center !important;\n}\n\n.gmSelectCell input {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--action-primary, #227ebd);\n}\n\n.gmRowOpenCell {\n  width: 40px;\n  min-width: 40px;\n  padding-right: 12px !important;\n  padding-left: 4px !important;\n  text-align: center !important;\n}\n\n.gmRowOpenCell span {\n  display: inline-block;\n  color: var(--text-subtle, #94a3b8);\n  font-size: 22px;\n  line-height: 1;\n  opacity: 0;\n  transform: translateX(-3px);\n  transition: opacity 0.15s ease, transform 0.15s ease;\n}\n\n.gmTable tbody tr:hover .gmRowOpenCell span,\n.gmTable tbody tr:focus-within .gmRowOpenCell span {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.gmMessageCell {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 230px;\n  max-width: 380px;\n}\n\n.gmMessageCell strong,\n.gmDateCell strong {\n  color: #101828;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.gmMessageCell span,\n.gmDateCell span,\n.gmAudience span {\n  color: #667085;\n  font-size: 12px;\n}\n\n.gmMessageCell span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.gmChannels {\n  display: flex;\n  gap: 6px;\n}\n\n.gmChannel {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #f2f4f7;\n  color: #cbd5e1;\n  opacity: 0.5;\n}\n\n.gmChannel--sms,\n.gmChannel--email {\n  background: #eaf3fb;\n  color: #1c5d8c;\n  opacity: 1;\n}\n.gmChannel--push {\n  background: #eaf3fb;\n  color: #1c5d8c;\n  opacity: 1;\n}\n\n.gmAudience {\n  display: flex;\n  align-items: center;\n  min-width: 150px;\n}\n\n.gmAudience strong {\n  display: block;\n  color: #101828;\n  font-size: 13px;\n}\n\n.gmDelivery {\n  min-width: 150px;\n}\n\n.gmDeliveryTrack {\n  position: relative;\n  height: 8px;\n  overflow: hidden;\n  border-radius: 999px;\n  background: #eef2f6;\n}\n\n.gmDeliveryTrack span {\n  position: absolute;\n  inset: 0 auto 0 0;\n  border-radius: inherit;\n}\n\n.gmDeliveryDelivered {\n  background: #bcd9c8;\n}\n\n.gmDeliveryMeta {\n  display: flex;\n  gap: 9px;\n  margin-top: 6px;\n  color: #667085;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.gmDeliveryMeta em {\n  color: #c6283f;\n  font-style: normal;\n}\n\n.gmStatusBadge {\n  display: inline-flex;\n  align-items: center;\n  height: 26px;\n  padding: 0 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 800;\n  text-transform: capitalize;\n}\n\n.gmStatusBadge--sent {\n  background: #e8f6ee;\n  color: #25784a;\n}\n.gmStatusBadge--scheduled {\n  background: #e7f2fb;\n  color: #1f5f86;\n}\n.gmStatusBadge--draft {\n  background: #f2f4f7;\n  color: #475467;\n}\n\n.gmDateCell {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  min-width: 150px;\n}\n\n.gmFooter {\n  min-height: 58px;\n  justify-content: space-between;\n  padding: 12px 14px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 0 0 11px 11px;\n  background: var(--surface-card, #fff);\n  color: #667085;\n  font-size: 13px;\n  font-weight: 600;\n}\n.gmFooter__pages {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n.gmFooter button {\n  display: inline-flex;\n  min-width: 34px;\n  height: 34px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 10px;\n  border: 1px solid #d0d5dd;\n  border-radius: 8px;\n  background: #fff;\n  color: #475467;\n  font-size: 12px;\n  font-weight: 700;\n}\n.gmFooter button:hover:not(:disabled) {\n  border-color: #6fb1df;\n  background: #eef6fc;\n  color: #155d8c;\n}\n\n.gmFooter button.is-active {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n.gmFooter button:disabled {\n  opacity: 0.48;\n  cursor: default;\n}\n.gmFooter i {\n  color: #98a2b3;\n  font-style: normal;\n}\n\n.gmDrawer {\n  position: fixed;\n  top: 76px;\n  right: 18px;\n  bottom: 18px;\n  z-index: 80;\n  width: min(520px, calc(100vw - 36px));\n  overflow: auto;\n  border: 1px solid #d9e2ea;\n  border-radius: 16px;\n  background: #fff;\n  box-shadow: 0 28px 70px rgba(15, 23, 42, 0.22);\n  padding: 18px;\n}\n\n.gmDetailsBackdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 5000;\n  display: flex;\n  align-items: stretch;\n  justify-content: flex-end;\n  padding: 0;\n  background: rgba(15, 23, 42, 0.3);\n}\n\n.gmDetailsModal {\n  display: flex;\n  flex-direction: column;\n  width: min(720px, calc(100vw - 24px));\n  height: 100%;\n  overflow: hidden;\n  border: 0;\n  border-left: 1px solid #d9e2ea;\n  border-radius: 0;\n  background: #fff;\n  box-shadow: -18px 0 48px rgba(15, 23, 42, 0.22);\n}\n\n.gmDetailsHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 20px;\n  padding: 18px 22px 16px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: linear-gradient(135deg, #ffffff 0%, #f7fbfe 72%, #eef6fc 100%);\n}\n\n.gmSentScopes button span {\n  display: inline-flex;\n  min-width: 19px;\n  height: 19px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 5px;\n  border-radius: 999px;\n  background: rgba(100, 116, 139, 0.12);\n  color: inherit;\n  font-size: 10px;\n  font-weight: 800;\n}\n\n.gmSentScopes button.is-active span {\n  background: var(--blue-50, #eef6fc);\n}\n\n.gmDetailsHeader > div:first-child {\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.gmDetailsHeader h2 {\n  margin: 8px 0 2px;\n  color: #101828;\n  font-size: 20px;\n  line-height: 1.25;\n}\n\n.gmDetailsHeader p {\n  margin: 0;\n  color: #667085;\n  font-size: 12.5px;\n}\n\n.gmDetailsHeaderChips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 12px;\n}\n\n.gmDetailsHeaderChip {\n  display: inline-flex;\n  min-height: 25px;\n  align-items: center;\n  gap: 5px;\n  padding: 0 9px;\n  border: 1px solid transparent;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 750;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n.gmDetailsHeaderChip svg {\n  width: 13px;\n  height: 13px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 2;\n}\n\n.gmDetailsHeaderChip.is-recipient {\n  border-color: #cfe3f3;\n  background: #eef6fc;\n  color: #155d8c;\n}\n\n.gmDetailsHeaderChip.is-priority {\n  border-color: #ffe2a8;\n  background: #fff6e6;\n  color: #8a4c08;\n}\n\n.gmDetailsHeaderChip.is-channel {\n  border-color: #ddd6fe;\n  background: #f5f3ff;\n  color: #6d4bc3;\n}\n\n.gmDetailsHeaderChip.is-ready {\n  border-color: #bfe7d0;\n  background: #eaf8f0;\n  color: #207449;\n}\n\n.gmDetailsHeaderChip.is-incomplete {\n  border-color: #fed7aa;\n  background: #fff7ed;\n  color: #a04b0c;\n}\n\n.gmDetailsTabs {\n  display: flex;\n  gap: 22px;\n  padding: 0 22px;\n  border-bottom: 1px solid #e4e7ec;\n}\n\n.gmDetailsTabs button {\n  height: 42px;\n  padding: 0 1px;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  background: transparent;\n  color: #667085;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.gmDetailsTabs button.is-active {\n  border-bottom-color: #227ebd;\n  color: #155d8c;\n}\n\n.gmDetailsBody {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: auto;\n  padding: 22px;\n  background: #f8fafc;\n}\n\n.gmMetricChips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 18px;\n}\n\n.gmMetricChips span {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  min-height: 29px;\n  padding: 0 10px;\n  border-radius: 999px;\n  background: #eef2f6;\n  color: #475467;\n  font-size: 11.5px;\n  font-weight: 700;\n}\n\n.gmMetricChips span.is-success {\n  background: #e8f6ee;\n  color: #25784a;\n}\n\n.gmMetricChips span.is-danger {\n  background: #fdecef;\n  color: #a8253a;\n}\n\n.gmDetailsGrid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.gmDetailsGrid > div,\n.gmAffected > div {\n  padding: 14px;\n  border: 1px solid #e2e8f0;\n  border-radius: 11px;\n  background: #fff;\n}\n\n.gmDetailsGrid span,\n.gmAffected span {\n  display: block;\n  margin-bottom: 5px;\n  color: #667085;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.gmDetailsGrid strong,\n.gmAffected strong {\n  color: #101828;\n  font-size: 13px;\n}\n\n.gmDeliveryStats {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 32px;\n  min-height: 390px;\n}\n\n.gmDeliveryLoading {\n  min-width: 116px;\n  min-height: 18px;\n  border-radius: 5px;\n  background: linear-gradient(90deg, #eef2f6 25%, #f8fafc 50%, #eef2f6 75%);\n  background-size: 200% 100%;\n  color: #64748b;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 700;\n  animation: gmDeliveryLoading 1.2s ease-in-out infinite;\n}\n\n@keyframes gmDeliveryLoading {\n  from {\n    background-position: 100% 0;\n  }\n  to {\n    background-position: -100% 0;\n  }\n}\n\n.gmDeliveryChannelTabs {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  background: #f8fafc;\n}\n\n.gmDeliveryStatsToolbar {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.gmDeliveryRefresh {\n  position: absolute;\n  right: 0;\n  display: inline-flex;\n  height: 36px;\n  padding: 0 13px;\n  align-items: center;\n  gap: 7px;\n  border: 1px solid #d0d5dd;\n  border-radius: 8px;\n  background: #fff;\n  color: #344054;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.gmDeliveryRefresh:hover {\n  border-color: #98a2b3;\n  background: #f8fafc;\n}\n\n.gmDeliveryRefresh svg {\n  width: 16px;\n  height: 16px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.9;\n}\n\n.gmDeliveryChannelTabs button {\n  padding: 7px 14px;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: #667085;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.gmDeliveryChannelTabs button.is-active {\n  background: #fff;\n  color: #245f91;\n  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.12);\n}\n\n.gmDeliveryChart {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 56px;\n}\n\n.gmDonut {\n  width: 230px;\n  height: 230px;\n  padding: 31px;\n  border-radius: 50%;\n}\n\n.gmDonut > div {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: inset 0 0 0 1px #e2e8f0;\n}\n\n.gmDonut strong {\n  color: #101828;\n  font-size: 30px;\n}\n\n.gmDonut span {\n  color: #667085;\n  font-size: 12px;\n}\n\n.gmDonutLegend {\n  display: grid;\n  gap: 12px;\n  min-width: 230px;\n}\n\n.gmDonutLegend span {\n  display: grid;\n  grid-template-columns: 10px 1fr auto;\n  align-items: center;\n  gap: 9px;\n  color: #475467;\n  font-size: 13px;\n}\n\n.gmDonutLegend i {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n}\n\n.gmDonutLegend i.is-delivered {\n  background: #35a66f;\n}\n.gmDonutLegend i.is-sent {\n  background: #3478c5;\n}\n.gmDonutLegend i.is-failed {\n  background: #d6455d;\n}\n.gmDonutLegend i.is-unavailable {\n  background: #9aa8b5;\n}\n.gmDonutLegend i.is-pending {\n  background: #dce5ec;\n}\n\n.gmContentTab {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  gap: 18px;\n  padding: 4px 0 18px;\n}\n\n.gmLaptop {\n  width: min(620px, calc(100% - 8px));\n  margin: 0 auto;\n}\n\n.gmLaptopLid {\n  position: relative;\n  padding: 11px 11px 12px;\n  border-radius: 16px 16px 8px 8px;\n  background: #1e293b;\n  box-shadow: 0 20px 42px rgba(15, 23, 42, 0.2);\n}\n\n.gmLaptopCamera {\n  position: absolute;\n  top: 4px;\n  left: 50%;\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background: #64748b;\n  transform: translateX(-50%);\n}\n\n.gmLaptopBar {\n  display: flex;\n  height: 34px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 12px;\n  border-radius: 8px 8px 0 0;\n  background: #e8edf3;\n  position: relative;\n}\n\n.gmLaptopBar span {\n  color: #64748b;\n  font-size: 10.5px;\n  font-weight: 700;\n}\n\n.gmLaptopWindowControls {\n  position: absolute;\n  left: 11px;\n  display: flex;\n  gap: 5px;\n}\n\n.gmLaptopWindowControls i {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #f87171;\n}\n\n.gmLaptopWindowControls i:nth-child(2) {\n  background: #fbbf24;\n}\n\n.gmLaptopWindowControls i:nth-child(3) {\n  background: #4ade80;\n}\n\n.gmLaptopScreen {\n  min-height: 350px;\n  max-height: 440px;\n  overflow: auto;\n  padding: 22px;\n  border-radius: 0 0 5px 5px;\n  background: linear-gradient(180deg, #f8fafc 0%, #edf2f7 100%);\n}\n\n.gmEmailMockup {\n  width: min(470px, 100%);\n  min-height: 290px;\n  margin: 0 auto;\n  overflow: hidden;\n  border: 1px solid #dbe4ee;\n  border-radius: 11px;\n  background: #fff;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);\n}\n\n.gmEmailMockup > header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 16px;\n  background: var(--brand-navy, #164170);\n  color: #fff;\n}\n\n.gmEmailMockupLogo {\n  display: inline-flex;\n  width: 32px;\n  height: 32px;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9px;\n  background: var(--brand-orange, #f26522);\n  color: #fff;\n  font-size: 16px;\n  font-weight: 850;\n}\n\n.gmEmailMockup > header strong,\n.gmEmailMockup > header span {\n  display: block;\n}\n\n.gmEmailMockup > header strong {\n  font-size: 13px;\n}\n\n.gmEmailMockup > header span {\n  margin-top: 2px;\n  color: rgba(255, 255, 255, 0.72);\n  font-size: 10px;\n}\n\n.gmEmailMockupBody {\n  padding: 22px 24px 28px;\n}\n\n.gmPreviewEyebrow {\n  display: block;\n  margin-bottom: 5px;\n  color: #64748b;\n  font-size: 9px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.gmEmailMockupBody h3 {\n  margin: 0 0 18px;\n  color: #0f172a;\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 19px;\n  line-height: 1.3;\n}\n\n.gmEmailMockupBody p {\n  margin: 0;\n  color: #334155;\n  font-size: 12px;\n  line-height: 1.65;\n  white-space: pre-wrap;\n}\n\n.gmPreviewEmpty {\n  padding: 28px 18px;\n  border: 1px dashed #cbd5e1;\n  border-radius: 9px;\n  background: #f8fafc;\n  color: #94a3b8;\n  font-size: 12px;\n  font-weight: 650;\n  text-align: center;\n}\n\n.gmLaptopBase {\n  position: relative;\n  width: calc(100% + 48px);\n  height: 14px;\n  margin-left: -24px;\n  border-radius: 2px 2px 16px 16px;\n  background: linear-gradient(180deg, #dbe2ea 0%, #aeb8c4 100%);\n  box-shadow: 0 10px 18px rgba(15, 23, 42, 0.15);\n}\n\n.gmLaptopBase span {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  width: 72px;\n  height: 5px;\n  border-radius: 0 0 6px 6px;\n  background: #8f9aa7;\n  transform: translateX(-50%);\n}\n\n.gmAffected {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.gmAffected em {\n  display: block;\n  margin-top: 7px;\n  color: #667085;\n  font-size: 12px;\n  font-style: normal;\n}\n\n.gmAffected .gmAffectedTotal {\n  border-color: #cfe1f2;\n  background: #eef6fc;\n}\n\n.gmAffected .gmAffectedRole {\n  border-color: #e2e8f0;\n  background: #fff;\n}\n\n.gmAffectedTotal strong {\n  font-size: 24px;\n  color: #155d8c;\n}\n\n.gmAffected .gmAffectedDelivery {\n  grid-column: span 2;\n  display: grid;\n  grid-template-columns: 1fr auto;\n  align-items: center;\n  column-gap: 18px;\n}\n\n.gmAffectedDelivery > span,\n.gmAffectedDelivery > strong,\n.gmAffectedDelivery > em {\n  grid-column: 1;\n}\n\n.gmAffectedDelivery > button {\n  grid-column: 2;\n  grid-row: 1 / span 3;\n}\n\n.gmDetailsActions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 14px 22px;\n  border-top: 1px solid #e4e7ec;\n  background: #fafbfc;\n}\n\n.gmDrawerHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.gmDrawerTitleRow {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  min-width: 0;\n}\n\n.gmDrawerIcon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n}\n\n.gmDrawerIcon svg {\n  width: 20px;\n  height: 20px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.9;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.gmDrawerIcon--sms {\n  background: #e8f6ee;\n  color: #2f9e5a;\n}\n.gmDrawerIcon--email {\n  background: #e7f2fb;\n  color: #227ebd;\n}\n.gmDrawerIcon--push {\n  background: #f0edfb;\n  color: #7b5bd6;\n}\n\n.gmDrawerHeader h2 {\n  margin: 8px 0 5px;\n  color: #101828;\n  font-size: 20px;\n  line-height: 1.25;\n  font-weight: 800;\n  letter-spacing: 0;\n}\n\n.gmDrawerHeader p {\n  margin: 0;\n  color: #667085;\n  font-size: 12.5px;\n  line-height: 1.4;\n}\n\n.gmIconButton {\n  width: 34px;\n  height: 34px;\n  padding: 0;\n  border-color: #d0d5dd;\n  background: #fff;\n  color: #475467;\n}\n\n.gmDrawerPanel {\n  padding: 14px 15px;\n  border-radius: 12px;\n  border: 1px solid #d9e2ea;\n  margin-bottom: 16px;\n}\n\n.gmDrawerPanel--sent {\n  background: #f7fbfc;\n  border-color: #cfe1e8;\n}\n.gmDrawerPanel--scheduled {\n  background: #e9f1fa;\n  border-color: #cfe1f2;\n}\n.gmDrawerPanel--draft {\n  background: #f8fafc;\n  border-color: #e4e7ec;\n}\n\n.gmDrawerPanelHeader {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.gmDrawerPanelHeader span,\n.gmDrawerSectionTitle {\n  color: #667085;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n}\n\n.gmDrawerPanelHeader strong {\n  color: #101828;\n  font-size: 14px;\n  font-weight: 800;\n}\n\n.gmDrawerPanel p {\n  margin: 10px 0 0;\n  color: #475467;\n  font-size: 12.5px;\n  line-height: 1.5;\n}\n\n.gmFunnel {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.gmFunnel--four {\n  grid-template-columns: repeat(4, 1fr);\n}\n\n.gmFunnel div {\n  padding: 9px 10px;\n  border-radius: 10px;\n  background: #fff;\n  border: 1px solid #e4e7ec;\n}\n\n.gmFunnel span {\n  display: block;\n  color: #667085;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.gmFunnel strong {\n  display: block;\n  margin-top: 3px;\n  color: #101828;\n  font-size: 18px;\n  font-weight: 800;\n}\n\n.gmDrawerProgress {\n  height: 8px;\n  overflow: hidden;\n  border-radius: 999px;\n  background: #e4e7ec;\n}\n\n.gmDrawerProgress span {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n  background: #227ebd;\n}\n\n.gmDrawerSectionTitle {\n  margin: 2px 0 10px;\n}\n\n.gmDrawerChannels {\n  display: inline-flex;\n  gap: 4px;\n  padding: 4px;\n  border-radius: 12px;\n  border: 1px solid #d9e2ea;\n  background: #f8fafc;\n  margin-bottom: 16px;\n}\n\n.gmDrawerChannels button {\n  height: 32px;\n  border: 0;\n  border-radius: 9px;\n  background: transparent;\n  color: #667085;\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 0 12px;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.gmDrawerChannels button.is-active {\n  background: #fff;\n  color: #174f64;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.12);\n}\n\n.gmPhoneFrame {\n  width: 286px;\n  margin: 0 auto;\n  padding: 10px;\n  border: 1px solid #0f172a;\n  border-radius: 42px;\n  background: linear-gradient(145deg, #263449, #0b1220);\n  box-shadow: 0 24px 48px rgba(15, 23, 42, 0.28), inset 0 0 0 1px rgba(255, 255, 255, 0.1);\n}\n\n.gmPhoneScreen {\n  position: relative;\n  height: 500px;\n  overflow: hidden;\n  border-radius: 33px;\n  display: flex;\n  flex-direction: column;\n}\n\n.gmPhoneScreen::before {\n  content: '';\n  position: absolute;\n  top: 7px;\n  left: 50%;\n  width: 74px;\n  height: 20px;\n  border-radius: 999px;\n  transform: translateX(-50%);\n  background: #101828;\n  z-index: 2;\n}\n\n.gmPhoneScreen--sms {\n  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);\n  padding: 40px 14px 18px;\n}\n.gmPhoneScreen--email {\n  background: #fff;\n  padding-top: 34px;\n}\n.gmPhoneScreen--push {\n  background: radial-gradient(circle at 72% 18%, rgba(92, 153, 203, 0.72), transparent 35%),\n    linear-gradient(160deg, #334e68, #101a2c 72%);\n  padding: 42px 12px 18px;\n  color: #fff;\n}\n\n.gmPhoneStatusBar {\n  position: absolute;\n  top: 10px;\n  right: 16px;\n  left: 16px;\n  z-index: 3;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  color: #0f172a;\n  font-size: 9px;\n  font-weight: 800;\n}\n\n.gmPhoneScreen--push .gmPhoneStatusBar {\n  color: #fff;\n}\n\n.gmPhoneStatusBar > div {\n  display: flex;\n  align-items: flex-end;\n  gap: 3px;\n}\n\n.gmPhoneStatusBar i {\n  display: block;\n  width: 3px;\n  height: 5px;\n  border-radius: 1px;\n  background: currentColor;\n}\n\n.gmPhoneStatusBar i:nth-child(2) {\n  height: 7px;\n}\n\n.gmPhoneStatusBar i:nth-child(3) {\n  width: 9px;\n  height: 6px;\n  border-radius: 2px;\n}\n\n.gmPhoneTop {\n  margin: 0 -14px 14px;\n  padding: 10px 14px 13px;\n  border-bottom: 1px solid rgba(15, 23, 42, 0.08);\n  text-align: center;\n  color: #101828;\n  font-size: 12.5px;\n  font-weight: 800;\n}\n\n.gmConversationDate {\n  display: block;\n  margin: 2px 0 12px;\n  color: #94a3b8;\n  font-size: 9px;\n  font-weight: 750;\n  text-align: center;\n  text-transform: uppercase;\n}\n\n.gmSmsBubble {\n  max-width: 82%;\n  margin: 0;\n  padding: 10px 13px;\n  border-radius: 18px 18px 18px 5px;\n  background: #e7e9ee;\n  color: #101828;\n  font-size: 13px;\n  line-height: 1.5;\n  white-space: pre-wrap;\n}\n\n.gmSmsBubble.is-empty {\n  border: 1px dashed #cbd5e1;\n  background: rgba(255, 255, 255, 0.72);\n  color: #94a3b8;\n}\n\n.gmEmailBar {\n  display: flex;\n  align-items: center;\n  min-height: 40px;\n  padding: 0 15px;\n  border-bottom: 1px solid rgba(15, 23, 42, 0.08);\n  color: #101828;\n  font-size: 12.5px;\n  font-weight: 800;\n}\n\n.gmEmailPreview {\n  flex: 1;\n  overflow: auto;\n  border: 0;\n  border-radius: 0;\n  background: #fff;\n  padding: 15px;\n  color: #334155;\n}\n\n.gmEmailPreview strong {\n  display: block;\n  color: #101828;\n  font-size: 16px;\n  line-height: 1.3;\n  margin-bottom: 10px;\n}\n\n.gmEmailPreview span {\n  display: block;\n  color: #64748b;\n  font-size: 11px;\n  margin-bottom: 12px;\n}\n\n.gmEmailPreview p {\n  margin: 0;\n  color: #334155;\n  font-size: 13px;\n  line-height: 1.6;\n  white-space: pre-wrap;\n}\n\n.gmPushClock {\n  text-align: center;\n  font-size: 56px;\n  line-height: 1;\n  font-weight: 300;\n  margin-top: 18px;\n  margin-bottom: auto;\n}\n\n.gmPushClock span {\n  display: block;\n  margin-top: 7px;\n  font-size: 11px;\n  font-weight: 650;\n}\n\n.gmPushPreview {\n  display: flex;\n  gap: 10px;\n  padding: 11px 12px;\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.92);\n  color: #334155;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.22);\n  margin-bottom: 18px;\n}\n\n.gmPushAppIcon {\n  width: 34px;\n  height: 34px;\n  border-radius: 9px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  background: #7b5bd6;\n  color: #fff;\n}\n\n.gmPushPreview span {\n  display: block;\n  color: #0e1726;\n  font-size: 11px;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.gmPushPreview strong {\n  display: block;\n  color: #101828;\n  font-size: 13.5px;\n  margin-top: 2px;\n}\n\n.gmPushPreview p {\n  margin: 2px 0 0;\n  color: #334155;\n  font-size: 12.5px;\n  line-height: 1.45;\n}\n\n.gmPhoneHomeIndicator {\n  position: absolute;\n  bottom: 7px;\n  left: 50%;\n  width: 86px;\n  height: 4px;\n  border-radius: 999px;\n  background: currentColor;\n  opacity: 0.68;\n  transform: translateX(-50%);\n}\n\n.gmDrawerActions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 16px;\n}\n\n.gmEmpty {\n  padding: 44px 20px;\n  text-align: center;\n  color: #667085;\n}\n\n.gmEmpty svg {\n  width: 34px;\n  height: 34px;\n  margin-bottom: 10px;\n}\n\n.gmEmpty h2 {\n  margin: 0 0 5px;\n  color: #101828;\n  font-size: 18px;\n}\n\n.gmEmpty p {\n  margin: 0;\n}\n\n.gmModalBackdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 100;\n  background: rgba(15, 23, 42, 0.42);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n\n.gmModal {\n  width: min(440px, 100%);\n  border-radius: 16px;\n  background: #fff;\n  padding: 22px;\n  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.25);\n}\n\n.gmModalIcon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #fde8ec;\n  color: #c6283f;\n  margin-bottom: 14px;\n}\n\n.gmModalIcon svg {\n  width: 22px;\n  height: 22px;\n}\n\n.gmModal h2 {\n  margin: 0 0 8px;\n  color: #101828;\n  font-size: 20px;\n  font-weight: 800;\n}\n\n.gmModal p {\n  margin: 0;\n  color: #667085;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.gmModalActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 20px;\n}\n\n.gmCopyModal {\n  width: min(520px, 100%);\n}\n\n.gmScheduleActionModal {\n  width: min(480px, 100%);\n}\n\n.gmScheduleActionModal__heading {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  min-width: 0;\n}\n\n.gmScheduleActionModal__heading > div {\n  min-width: 0;\n}\n\n.gmScheduleActionModal__heading h2 {\n  margin-bottom: 4px;\n}\n\n.gmScheduleActionModal__heading p {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.gmScheduleActionModal__icon {\n  width: 40px;\n  height: 40px;\n  flex: 0 0 40px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-600, #1a6da3);\n}\n\n.gmScheduleActionModal__icon svg {\n  width: 20px;\n  height: 20px;\n}\n\n.gmScheduleActionModal__description {\n  margin-top: 16px !important;\n  padding: 12px 14px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 10px;\n  background: var(--surface-page, #f8fafc);\n  color: var(--text-body, #334155) !important;\n}\n\n.gmScheduleActionModal__field {\n  margin-top: 18px;\n}\n\n.gmScheduleActionModal__field .gmScheduleDateTimePicker {\n  width: 100%;\n}\n\n.gmScheduleActionModal__error {\n  margin-top: 12px;\n  padding: 9px 11px;\n  border-radius: 8px;\n  background: #fff1f3;\n  color: #b4233b;\n  font-size: 12.5px;\n  font-weight: 600;\n}\n\n.gmCopyModal__heading {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  min-width: 0;\n}\n\n.gmCopyModal__heading > div {\n  min-width: 0;\n}\n\n.gmCopyModal__heading h2 {\n  margin-bottom: 4px;\n}\n\n.gmCopyModal__heading p {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.gmCopyModal__icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  background: #eef6fc;\n  color: #227ebd;\n}\n\n.gmCopyModal__icon svg {\n  width: 19px;\n  height: 19px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.8;\n}\n\n.gmCopyOptions {\n  display: grid;\n  gap: 8px;\n  margin-top: 18px;\n}\n\n.gmCopyOption {\n  position: relative;\n  display: grid;\n  grid-template-columns: 20px minmax(0, 1fr);\n  align-items: center;\n  gap: 11px;\n  min-height: 58px;\n  margin: 0;\n  padding: 10px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  background: #fff;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;\n}\n\n.gmCopyOption:hover {\n  border-color: #93bddd;\n  background: #fafcff;\n}\n\n.gmCopyOption.is-selected {\n  border-color: #7eb3d8;\n  background: #eef6fc;\n  box-shadow: inset 3px 0 0 #227ebd;\n}\n\n.gmCopyOption input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.gmCopyOption__check {\n  width: 18px;\n  height: 18px;\n  border: 1px solid #cbd5e1;\n  border-radius: 5px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #fff;\n  color: transparent;\n  font-size: 12px;\n  font-weight: 800;\n  line-height: 1;\n}\n\n.gmCopyOption.is-selected .gmCopyOption__check {\n  border-color: #227ebd;\n  background: #227ebd;\n  color: #fff;\n}\n\n.gmCopyOption strong,\n.gmCopyOption small {\n  display: block;\n}\n\n.gmCopyOption strong {\n  color: #0f172a;\n  font-size: 13px;\n  font-weight: 750;\n}\n\n.gmCopyOption small {\n  margin-top: 2px;\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 1.35;\n}\n\n.gmCopyModal__error {\n  margin-top: 10px;\n  color: #b42318;\n  font-size: 12px;\n  font-weight: 650;\n}\n\n.gmToast {\n  position: fixed;\n  right: 20px;\n  bottom: 20px;\n  z-index: 120;\n  padding: 11px 14px;\n  border-radius: 10px;\n  background: #101828;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 700;\n  box-shadow: 0 16px 34px rgba(15, 23, 42, 0.24);\n}\n\n@media (max-width: 1217px) {\n  .gmPageHeader {\n    width: 100vw;\n    margin-left: -12px;\n    padding-right: 28px;\n  }\n}\n\n@media (max-width: 900px) {\n  .gmPage {\n    padding: 0 0 24px;\n  }\n  .gmPageHeader {\n    width: 100vw;\n    height: auto;\n    min-height: 70px;\n    flex-wrap: wrap;\n    gap: 0 16px;\n    margin: -16px 0 14px -16px;\n    padding: 10px 16px 0;\n  }\n  .gmPageHeader h1 {\n    overflow: hidden;\n    font-size: 20px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  .gmPageHeader > .gmButton {\n    margin-left: auto;\n  }\n  .gmHeader,\n  .gmSelectionBar {\n    align-items: stretch;\n    flex-direction: column;\n  }\n  .gmTabs {\n    width: 100%;\n    height: 42px;\n    flex-basis: 100%;\n    order: 3;\n  }\n  .gmTabs button {\n    flex: 0 0 auto;\n  }\n  .gmToolbar {\n    display: grid;\n    grid-template-columns: auto auto minmax(0, 1fr);\n    min-height: 0;\n    align-items: center;\n    justify-content: initial;\n    gap: 8px;\n    padding: 10px 12px;\n  }\n  .gmSearch {\n    grid-column: 1 / -1;\n    width: 100%;\n    max-width: none;\n    flex: none;\n  }\n  .gmSelect {\n    width: 100%;\n  }\n  .gmFilterButton {\n    grid-column: 1;\n  }\n  .gmColumns {\n    grid-column: 2;\n  }\n  .gmColumnsButton > span {\n    display: none;\n  }\n  .gmToolbarSpacer {\n    display: none;\n  }\n  .gmSentScopes {\n    grid-column: 3;\n    justify-self: end;\n    align-self: center;\n  }\n  .gmFilters {\n    position: fixed;\n    top: 66px;\n    right: 0;\n    bottom: 0;\n    left: auto;\n    z-index: 1200;\n    width: min(360px, 100%);\n    max-height: none;\n    overflow-y: auto;\n    padding: 18px 16px max(18px, env(safe-area-inset-bottom));\n    border-radius: 0;\n    box-shadow: -12px 0 34px rgba(15, 23, 42, 0.2);\n  }\n  .gmFiltersActions {\n    position: sticky;\n    bottom: 0;\n    margin: 0 -16px -18px;\n    padding: 14px 16px max(14px, env(safe-area-inset-bottom));\n    background: #fff;\n  }\n  .gmTableCard {\n    overflow-x: auto;\n  }\n  .gmTable {\n    width: 100%;\n  }\n  .gmFooter {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n  .gmFooter__pages {\n    max-width: 100%;\n    overflow-x: auto;\n  }\n  .gmDrawer {\n    top: 64px;\n    right: 10px;\n    bottom: 10px;\n    width: calc(100vw - 20px);\n  }\n  .gmDetailsBackdrop {\n    inset: 0;\n    padding: 0;\n  }\n  .gmDetailsModal {\n    width: min(100%, 720px);\n    height: 100%;\n  }\n  .gmDetailsTabs {\n    overflow-x: auto;\n  }\n  .gmDetailsTabs button {\n    flex: 0 0 auto;\n  }\n  .gmDetailsHeader {\n    padding: 15px 16px 14px;\n  }\n  .gmDetailsHeaderChips {\n    max-height: 62px;\n    overflow-y: auto;\n  }\n  .gmDetailsBody {\n    padding: 16px;\n  }\n  .gmLaptop {\n    width: calc(100% - 24px);\n  }\n  .gmLaptopScreen {\n    min-height: 310px;\n    padding: 14px;\n  }\n  .gmLaptopBase {\n    width: calc(100% + 28px);\n    margin-left: -14px;\n  }\n  .gmDetailsGrid,\n  .gmAffected {\n    grid-template-columns: 1fr;\n  }\n  .gmAffected .gmAffectedDelivery {\n    grid-column: 1;\n    grid-template-columns: 1fr;\n  }\n  .gmAffectedDelivery > button {\n    grid-column: 1;\n    grid-row: auto;\n    margin-top: 12px;\n  }\n  .gmDeliveryStats {\n    flex-direction: column;\n    gap: 26px;\n  }\n  .gmDetailsActions {\n    align-items: stretch;\n    flex-direction: column;\n    overflow-y: auto;\n  }\n}\n\n@media (max-width: 340px) {\n  .gmToolbar {\n    grid-template-columns: auto minmax(0, 1fr);\n  }\n  .gmSentScopes {\n    grid-column: 1 / -1;\n    justify-self: start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
